import { Component } from 'solid-js'
import { INITIAL_TOKEN_PLANS } from '/common/token-plans'

interface BonusTokensButtonProps {
  tokenCount?: number
  className?: string
  size?: 'small' | 'large'
  hideTokenCount?: boolean
}

const BonusTokensButton: Component<BonusTokensButtonProps> = (props) => {
  const tokenCount = props.tokenCount || INITIAL_TOKEN_PLANS[0].amount
  const className = props.className || ''
  const size = props.size || 'small'
  const hideTokenCount = props.hideTokenCount || false

  const isLarge = size === 'large'

  const buttonClasses = isLarge ? 'h-[242px] w-[239px]' : 'h-[121px] w-[123px]'

  const backgroundImage = isLarge
    ? '/images/free-bonus-tokens-wavy-circle-lg.png'
    : '/images/free-bonus-tokens-wavy-circle.png'

  const numberSize = isLarge ? 'text-[60px]' : 'text-[24px]'
  const textSize = isLarge
    ? hideTokenCount
      ? 'text-[45px] leading-[50px]'
      : 'text-[34px] leading-[40px]'
    : hideTokenCount
    ? 'text-[20px]'
    : 'text-[18px]'
  const marginSize = isLarge
    ? hideTokenCount
      ? '-mt-4'
      : 'mt-6'
    : hideTokenCount
    ? '-mt-1 mx-4'
    : 'mt-[6px]'

  return (
    <button
      class={`relative flex ${buttonClasses} items-center justify-center text-base font-semibold ${className}`}
    >
      <img
        src={backgroundImage}
        alt={hideTokenCount ? 'Free Bonus Tokens' : `${tokenCount} Free Bonus Tokens`}
        class="absolute left-0 top-0 h-full w-full"
      />
      <span
        class={`relative font-semibold text-white [text-shadow:0_0_2px_rgba(0,0,0,0.9),0_0_2px_rgba(0,0,0,0.9),-1px_-1px_0_rgba(0,0,0,0.9),1px_-1px_0_rgba(0,0,0,0.9),-1px_1px_0_rgba(0,0,0,0.9),1px_1px_0_rgba(0,0,0,0.9),0_4px_4px_rgba(0,0,0,0.5)] ${marginSize}`}
      >
        {!hideTokenCount && <span class={numberSize}>{tokenCount}</span>}
        <span class={textSize}> Free Bonus Tokens!</span>
      </span>
    </button>
  )
}

export default BonusTokensButton
